<template>
  <div class="tkHeaderAccordion" v-bind="$attrs">
    <div class="tkHeaderAccordion_button"
      :class="{ 'tkHeaderAccordion_button--showed': isShow }"
      @click="showSwitching"
    >
      <div class="tkHeaderAccordion_title">
        {{ title }}
        <div class="tkHeaderAccordion_arrow">
          <template v-if="isShow">
            <tk-up-arrow />
          </template>
          <template v-else>
            <tk-down-arrow />
          </template>
        </div>
      </div>
    </div>
    <div v-if="isShow" class="tkHeaderAccordion_contents">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import TkDownArrow from '../arrow/TkDownArrow/TkDownArrow'
import TkUpArrow from '../arrow/TkUpArrow/TkUpArrow'

export default {
  name: 'TkHeaderAccordion',
  components: {
    TkDownArrow,
    TkUpArrow,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShow: this.show,
    }
  },
  methods: {
    showSwitching() {
      this.isShow = !this.isShow;
      this.$emit('switching', this.isShow)
    },
  },
}
</script>

<style lang="scss">
.tkHeaderAccordion_button {
  cursor: pointer;
}

.tkHeaderAccordion_title {
  position: relative;
}

.tkHeaderAccordion_arrow {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
}
</style>
